<!-- eslint-disable max-len -->
<template>
  <svg
    width="69"
    height="36"
    viewBox="0 0 69 36"
    fill="currentColor"
    class="icons-svg"
  >
    <g clip-path="url(#prefix__clip0)">
      <path
        d="M67.798 17.181c-.172-.361-1.338-2.8-2.036-4.252-.8-1.672-1.776-1.885-2.629-1.885H49.45a1.493 1.493 0 00-1.341.843l-1.034 2.178-.1.22a1.7 1.7 0 00-.164.646v19.33a1.306 1.306 0 001.277 1.268h4.626a1.305 1.305 0 001.277-1.269V18.974a1.08 1.08 0 01.258-.443 1.057 1.057 0 01.79-.309h4.8a1.064 1.064 0 01.79.31c.201.21.312.49.309.781v1.155c.004.291-.107.573-.309.783a1.06 1.06 0 01-.79.31H58.36a1.49 1.49 0 00-1.342.851l-2 4.149a1.485 1.485 0 001.338 2.121h7.262c.727-.1 1.5-.515 2.151-1.882.694-1.451 1.862-3.837 2.036-4.2a2.3 2.3 0 00.3-1.277v-2.869a2.29 2.29 0 00-.307-1.273zM34.86 28.686h5.694c.85 0 1.83-.21 2.628-1.885l2.036-4.252c.222-.387.326-.831.3-1.277v-8.955a1.306 1.306 0 00-1.277-1.269h-3.252a1.5 1.5 0 00-1.342.843l-1.034 2.178-.105.22a1.699 1.699 0 00-.164.646v5.514c.003.292-.108.573-.31.783a1.057 1.057 0 01-.79.31h-5.1a1.064 1.064 0 01-.79-.31 1.114 1.114 0 01-.31-.783v-5.517a1.662 1.662 0 00-.164-.646l-.105-.22-1.034-2.178a1.5 1.5 0 00-1.342-.843h-3.255a1.307 1.307 0 00-1.277 1.27v8.956c-.027.446.078.89.3 1.277.172.361 1.338 2.8 2.036 4.252.8 1.671 1.775 1.885 2.628 1.885h6.032l-.003.001zM15.199 7.952a1.469 1.469 0 01-.209 1.549l-5.472 6.84a1.483 1.483 0 00-.182 1.576l2.007 4.183a1.484 1.484 0 002.5.285L25.56 7.737a1.489 1.489 0 00.176-1.571l-1.277-2.661L23.182.846A1.492 1.492 0 0021.844 0H3.078A1.482 1.482 0 001.74 2.128l2.012 4.18a1.486 1.486 0 001.347.841h8.76a1.464 1.464 0 011.338.806l.002-.003z"
        fill="#6e6e72"
      ></path>
      <path
        d="M10.682 20.712a1.469 1.469 0 01.21-1.549l5.471-6.84a1.482 1.482 0 00.182-1.576L14.54 6.564a1.484 1.484 0 00-2.5-.284L.323 20.928a1.488 1.488 0 00-.176 1.571l1.277 2.661 1.277 2.66a1.49 1.49 0 001.338.847h18.757a1.485 1.485 0 001.338-2.128l-2.012-4.18a1.482 1.482 0 00-1.346-.84H12.02a1.466 1.466 0 01-1.34-.805l.002-.002z"
        fill="#6e6e72"
      ></path>
      <path
        d="M14.705 8.903l-5.482 6.835a1.485 1.485 0 00-.187 1.576l1.91 3.957a1.465 1.465 0 01.224-1.5l5.48-6.835a1.486 1.486 0 00.186-1.576l-1.9-3.958a1.464 1.464 0 01-.23 1.501z"
        fill="#6e6e72"
      ></path>
      <path
        d="M14.944 7.396l-.4-.833a1.484 1.484 0 00-2.5-.284l-.694.866a1.737 1.737 0 011.575.992l.471.982a1.718 1.718 0 01-.2 1.659l1.51-1.882a1.466 1.466 0 00.238-1.5zM10.946 21.262l.4.832a1.484 1.484 0 002.5.285l.694-.87a1.736 1.736 0 01-1.575-.991l-.47-.982a1.719 1.719 0 01.2-1.659l-1.51 1.882a1.472 1.472 0 00-.239 1.503z"
        fill="#6e6e72"
      ></path>
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path fill="#6e6e72" d="M0 0h68.102v35.529H0z"></path>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Zup',
};
</script>
